import { Component } from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { ProspectsService } from '../../services/prospects/prospects.service';
import { CampaignService } from '../../services/campaigns/campaign.service';
import { rankQueue, RankedProspect } from '../../services/lead-ranking/warmth-score';

/**
 * Lead Ranking v1 — a warmth-ranked dial queue. Reuses ProspectsService.getProspects() +
 * CampaignService.getCampaignsForSelect() BY CALL ONLY; scoring lives in warmth-score.ts.
 * No existing prospects/dispo files are modified.
 */
@Component({
	selector: 'app-lead-ranking',
	templateUrl: './lead-ranking.component.html',
	styleUrls: ['./lead-ranking.component.scss'],
})
export class LeadRankingComponent {
	ColumnMode = ColumnMode;
	campaigns: any[] = [];
	selectedCampaign: any = null;
	loading = false;
	loaded = false;
	ranked: RankedProspect[] = [];
	excludedCount = 0;
	counts = { hot: 0, warm: 0, cold: 0 };

	constructor(private prospectSrv: ProspectsService, private campaignsSrv: CampaignService) {
		this.campaignsSrv.getCampaignsForSelect().subscribe((res: any) => {
			this.campaigns = Array.isArray(res?.body) ? res.body : [];
		});
	}

	getQueue(): void {
		if (this.selectedCampaign == null || this.selectedCampaign === '') return;
		this.loading = true;
		this.loaded = false;
		this.prospectSrv.getProspects(Number(this.selectedCampaign)).subscribe({
			next: (res: any) => {
				const r = rankQueue(res?.body, new Date());
				this.ranked = r.ranked;
				this.excludedCount = r.excludedCount;
				this.counts = r.counts;
				this.loading = false;
				this.loaded = true;
			},
			error: () => {
				this.ranked = [];
				this.excludedCount = 0;
				this.counts = { hot: 0, warm: 0, cold: 0 };
				this.loading = false;
				this.loaded = true;
			},
		});
	}

	tierClass(tier: string): string {
		return tier === 'hot' ? 'bg-danger' : tier === 'warm' ? 'bg-warning' : 'bg-secondary';
	}

	fullName(p: any): string {
		return [p?.title, p?.first_name, p?.last_name].filter(Boolean).join(' ').trim();
	}
}
